const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function initializeStbeMotion(root = document) {
  const main = root.matches?.('main[data-template="index"]')
    ? root
    : root.querySelector?.('main[data-template="index"]') || document.querySelector('main[data-template="index"]');

  if (!main || reducedMotion.matches) return;

  document.documentElement.classList.add('stbe-motion-ready');
  const sections = [...main.querySelectorAll(':scope > .shopify-section')];
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('stbe-reveal--visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  sections.forEach((section, index) => {
    if (section.dataset.stbeMotionReady === 'true') return;
    section.dataset.stbeMotionReady = 'true';
    section.classList.add('stbe-reveal');

    if (index === 0 || section.getBoundingClientRect().top < window.innerHeight * 0.9) {
      section.classList.add('stbe-reveal--visible');
      return;
    }

    observer.observe(section);
  });
}

function initializeHeroCarousel(root = document) {
  const carousels = root.matches?.('[data-stbe-hero-carousel]')
    ? [root]
    : [...(root.querySelectorAll?.('[data-stbe-hero-carousel]') || [])];

  carousels.forEach((carousel) => {
    if (carousel.dataset.stbeCarouselReady === 'true') return;

    const slides = [...carousel.querySelectorAll('[data-stbe-hero-slide]')];
    const dots = [...carousel.querySelectorAll('[data-stbe-hero-dot]')];
    const previous = carousel.querySelector('[data-stbe-hero-prev]');
    const next = carousel.querySelector('[data-stbe-hero-next]');
    if (slides.length < 2) return;

    carousel.dataset.stbeCarouselReady = 'true';
    let current = 0;
    let timer;

    const showSlide = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === current)));
    };

    const stopRotation = () => window.clearInterval(timer);
    const startRotation = () => {
      stopRotation();
      if (reducedMotion.matches) return;
      timer = window.setInterval(() => showSlide(current + 1), 4200);
    };

    previous?.addEventListener('click', () => {
      showSlide(current - 1);
      startRotation();
    });
    next?.addEventListener('click', () => {
      showSlide(current + 1);
      startRotation();
    });
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        showSlide(Number(dot.dataset.index));
        startRotation();
      });
    });

    carousel.addEventListener('pointerenter', stopRotation);
    carousel.addEventListener('pointerleave', startRotation);
    carousel.addEventListener('focusin', stopRotation);
    carousel.addEventListener('focusout', startRotation);
    startRotation();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initializeStbeMotion();
    initializeHeroCarousel();
  });
} else {
  initializeStbeMotion();
  initializeHeroCarousel();
}

document.addEventListener('shopify:section:load', (event) => {
  initializeStbeMotion(event.target);
  initializeHeroCarousel(event.target);
});
